<div style="width: 70%; margin-right: auto; margin-left: auto">

  <ul class="nav nav-tabs mb-3">
    <li class="nav-item">
      <button class="nav-link" type="button"
              [class.active]="selectedValidationTab === 'hubGarmin'"
              (click)="selectValidationTab('hubGarmin')">Hub/Garmin</button>
    </li>
    <li class="nav-item">
      <button class="nav-link" type="button"
              [class.active]="selectedValidationTab === 'iridium'"
              (click)="selectValidationTab('iridium')">Iridium</button>
    </li>
  </ul>

  <div *ngIf="selectedValidationTab === 'hubGarmin'">
    <h2>Hub/Garmin Validation</h2>

    <!-- Region Dropdown -->
    <div class="mb-3">
      <label for="region" class="form-label">Region</label>
      <select id="region" [(ngModel)]="selectedRegion" class="form-select">
        <option [value]="Region.US">US</option>
        <option [value]="Region.CA">CA</option>
      </select>
    </div>

    <div class="mb-3">
      <label for="imeis" class="form-label">IMEI(s)*</label>
      <span style="color: gray; font-size: 12px; padding-left: 5px;">comma or line-separated list</span>
      <textarea [cdkTextareaAutosize]="true" id="imeis" class="form-control" [(ngModel)]="imeisString"></textarea>
    </div>
    <div class="mb-3">
      <button class="btn btn-primary" type="button"
              (click)="validateImeis()"
              [disabled]="validationDisabled">validate imeis</button>
    </div>
    <div class="alert alert-success" role="alert" *ngIf="imeiValidationResult">IMEIs are valid and ready to be activated.</div>
    <div class="alert alert-danger" role="alert" *ngIf="hasErrorMessage()">
      <div>{{malformedImeiMessage}}</div>
      <div>{{notFoundImeiMessage}}</div>
      <div>{{deactivateImeiMessage}}</div>
      <div>{{activeOnHubMessage}}</div>
    </div>

    <div class="table-responsive" *ngIf="imeiResults.length > 0">
      <table class="table table-striped validation-results-table">
        <thead>
          <tr>
            <th>IMEI</th>
            <th>Status</th>
            <th>Garmin Network Status</th>
            <th>Garmin User Id</th>
            <th>Hub Device Name</th>
            <th>Hub Team Id</th>
            <th>Rejection Reason</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let response of imeiResults">
            <td>{{response.imeiInfo.imei}}</td>
            <td>{{response.imeiInfo.imeiStatus}}</td>
            <td>{{response.imeiInfo.garminNetworkStatus}}</td>
            <td>{{response.imeiInfo.garminUserId}}</td>
            <td>{{response.imeiInfo.hubDeviceName}}</td>
            <td>{{response.imeiInfo.teamId}}</td>
            <td>{{response.rejectionReason}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="selectedValidationTab === 'iridium'">
    <h2>Iridium Validation</h2>

    <div class="mb-3">
      <label for="iridiumImeis" class="form-label">IMEI(s)*</label>
      <span style="color: gray; font-size: 12px; padding-left: 5px;">comma or line-separated list, max 10</span>
      <textarea [cdkTextareaAutosize]="true" id="iridiumImeis" class="form-control" [(ngModel)]="iridiumImeisString"></textarea>
    </div>
    <div class="mb-3">
      <button class="btn btn-primary" type="button"
              (click)="validateIridiumImeis()"
              [disabled]="iridiumValidationDisabled">validate imeis</button>
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="iridiumValidationError">{{iridiumValidationError}}</div>

    <div class="table-responsive" *ngIf="iridiumResults.length > 0">
      <table class="table table-striped validation-results-table">
        <thead>
          <tr>
            <th>IMEI</th>
            <th>Service Type</th>
            <th>Account Status</th>
            <th *ngIf="hasIridiumAccountResults()">Created Date</th>
            <th *ngIf="hasIridiumAccountResults()">Created By</th>
            <th *ngIf="hasIridiumAccountResults()">Delivery Destination</th>
            <th>Home Gateway</th>
            <th>Reason</th>
            <th>Valid</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let response of iridiumResults">
            <td>{{response.imei}}</td>
            <td>{{response.serviceCategory}}</td>
            <td>{{response.accountStatus}}</td>
            <td *ngIf="hasIridiumAccountResults()">{{response.createDate}}</td>
            <td *ngIf="hasIridiumAccountResults()">{{response.createdBy}}</td>
            <td *ngIf="hasIridiumAccountResults()">{{response.deliveryDestinations}}</td>
            <td>{{response.homeGateway}}</td>
            <td>{{response.reason}}</td>
            <td>{{response.valid}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
